// Skips --accent-sage on purpose — that's the primary action colour, so we
// want hashed labels to feel distinct from buttons/checkmarks.
const PALETTE = [
	'--accent-apricot',
	'--accent-lilac',
	'--accent-sky',
	'--accent-rose',
	'--accent-sunshine',
	'--accent-terracotta',
] as const

// DJB2 — small, fast, deterministic. We only care about even bucketing.
const hash = (s: string): number => {
	let h = 5381
	for (let i = 0; i < s.length; i++) {
		h = (h * 33) ^ s.charCodeAt(i)
	}
	return h >>> 0
}

export const colorFor = (name: string): string =>
	`var(${PALETTE[hash(name.toLowerCase()) % PALETTE.length]})`
